export * from '@fluentui/theme/lib/spacing/DefaultSpacing';
